export const isPossibleValue = (value, possibleValues) => {
  return possibleValues.includes(value);
};